import * as React from 'react';
import { Rating } from "./Rating";
import { translate } from "@js/common/helpers";
var List = function (_a) {
    var ratings = _a.ratings, user = _a.user, afterRatingChange = _a.afterRatingChange;
    return (React.createElement("div", { id: "ratingsList" },
        React.createElement("h5", null, translate('collection_rating.title')), ratings === null || ratings === void 0 ? void 0 :
        ratings.map(function (rating) {
            return React.createElement(Rating, { initialData: rating, key: rating.id, user: user, afterRatingChange: afterRatingChange });
        })));
};
export { List };
